import { InAppNotification, PushAlertConfig } from '../types/energy';
import { INITIAL_NOTIFICATIONS } from './mockData';
import { 
  getSqliteNotifications, 
  saveSqliteNotifications 
} from './sqliteDatabase';

// In-memory fast cache
let inMemoryNotifs: InAppNotification[] = INITIAL_NOTIFICATIONS;
let inMemoryPushConfig: PushAlertConfig = {
  billingCycles: true,
  dueReminderDaysBefore: 3,
  peakUsageSurges: true,
  scrapeStatusSync: true,
  monthlyBudgetLimit: 12000,
  monthlyBudgetAlerts: true,
  browserNotificationsGranted: typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted'
};

// Initial background load from SQLite WASM
getSqliteNotifications().then((loaded) => {
  if (loaded && loaded.length > 0) {
    inMemoryNotifs = loaded;
  }
}).catch(() => {
  // ignore
});

export function getStoredPushConfig(): PushAlertConfig {
  return inMemoryPushConfig;
}

export function saveStoredPushConfig(config: PushAlertConfig): void {
  inMemoryPushConfig = config;
}

export function getStoredNotifications(): InAppNotification[] {
  return inMemoryNotifs;
}

export function saveStoredNotifications(notifs: InAppNotification[]): void {
  inMemoryNotifs = notifs;
  saveSqliteNotifications(notifs).catch((err) => {
    console.error('[SQLite WASM] Failed saving notifications to SQLite', err);
  });
}

export async function requestBrowserPushPermission(): Promise<boolean> {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return false;
  }
  try {
    const perm = await Notification.requestPermission();
    const isGranted = perm === 'granted';
    inMemoryPushConfig.browserNotificationsGranted = isGranted;
    return isGranted;
  } catch (e) {
    console.error('Permission request failed', e);
    return false;
  }
}

export function dispatchPushNotification(
  title: string,
  body: string,
  type: InAppNotification['type'],
  amount?: number
): InAppNotification {
  const notif: InAppNotification = {
    id: `notif-${Date.now()}-${Math.random().toString(36).substr(2, 4)}`,
    title,
    body,
    type,
    amount,
    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    read: false
  };

  const updated = [notif, ...inMemoryNotifs];
  saveStoredNotifications(updated);

  if (typeof window !== 'undefined' && 'Notification' in window && Notification.permission === 'granted') {
    try {
      new Notification(title, {
        body,
        icon: '/favicon.ico',
        badge: '/favicon.ico'
      });
    } catch {
      // ignore
    }
  }

  return notif;
}
